export const useAdTargetingCategoryPage = (name: string) => {
  if (import.meta.client && window?.googletag?.cmd) {
    window.googletag.cmd.push(function () {
      const {
        appEnv,
        ad: { targetPrefix }
      } = useRuntimeConfig().public;

      window.googletag.pubads().setTargeting(`${targetPrefix}_category`, name);
      window.googletag.pubads().setTargeting('ads_env', appEnv);
      window.googletag.pubads().setTargeting('user_login', `${document.cookie.includes('oneid_info')}`);
      window.googletag.pubads().setTargeting('cpp', 'true');
      window.googletag.pubads().setTargeting('dn_testads', `${getTestAdStatus()}`);

      const screenWidthTargetRange = getScreenWidthTargetRange();
      if (screenWidthTargetRange) {
        window.googletag.pubads().setTargeting('screen_width_range', screenWidthTargetRange);
      }
    });
  }
};
